import Vue from 'vue'
import App from './App.vue'
import 'amfe-flexible'
// 引入重置样式表
import '@/assets/css/reset.css'
import less from 'less'
Vue.use(less)

//导入所有组件。
import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);
// 引入路由文件
import router from '@/router/index.js';
// 引入vant 提供过的懒加载
import { Lazyload } from 'vant';
Vue.use(Lazyload);

Vue.config.productionTip = false

//全局过滤器
Vue.filter('moneyFlrmat',function(value){
    return `￥${value.toFixed(2)}元`

})


new Vue({
  render: h => h(App),
  router
}).$mount('#app')
